// src/config/stripeProducts.js
//
// Price ID naming convention:
//   monthly     = USD monthly
//   annual      = USD annual
//   monthly_cad = CAD monthly
//   annual_cad  = CAD annual
//
// USD prices: $49 / $129 / $249 / $449 per month
// CAD prices: $59 / $149 / $299 / $499 per month (native CAD, no conversion)
//
// ✅ LIVE MODE Price IDs — updated March 21, 2026
// Test mode IDs have been replaced with live mode IDs.
// Do not revert to test IDs — all real customer signups must use live IDs.

export const STRIPE_PRODUCTS = {
  solo: {
    name: "Spatchy Solo",
    userLimit: 1,
    prices: {
      monthly:     "price_1TDR68BTQT1Q7jElOwyA5uCK", // USD $49/mo
      annual:      "price_1TDR67BTQT1Q7jElkKu1jCVq", // USD $468/yr
      monthly_cad: "price_1TDR67BTQT1Q7jElw1gQjfIj", // CAD $59/mo
      annual_cad:  "price_1TDR66BTQT1Q7jEl2QfbLe1w", // CAD $566.40/yr
    },
    displayPrices: {
      monthly_usd: 49,
      annual_usd:  468,
      monthly_cad: 59,
      annual_cad:  566.40,
    },
    features: ["CRM", "Invoicing", "Job Management", "AI Tools"],
  },
  starter: {
    name: "Spatchy Starter",
    userLimit: 5,
    prices: {
      monthly:     "price_1TDR68BTQT1Q7jElaOlsXzBW", // USD $129/mo
      annual:      "price_1TDR68BTQT1Q7jElRQBbc6Z4", // USD $1,236/yr
      monthly_cad: "price_1TDR67BTQT1Q7jElUPlHFchK", // CAD $149/mo
      annual_cad:  "price_1TDR66BTQT1Q7jElJrNxLUNu", // CAD $1,430.40/yr
    },
    displayPrices: {
      monthly_usd: 129,
      annual_usd:  1236,
      monthly_cad: 149,
      annual_cad:  1430.40,
    },
    features: ["All Solo Features", "Up to 5 Users", "Team Calendars"],
  },
  growth: {
    name: "Spatchy Growth",
    userLimit: 10,
    prices: {
      monthly:     "price_1TDR68BTQT1Q7jElvzQ9jRGJ", // USD $249/mo
      annual:      "price_1TDR68BTQT1Q7jEla1jvJGCV", // USD $2,388/yr
      monthly_cad: "price_1TDR68BTQT1Q7jElNVOd40AG", // CAD $299/mo
      annual_cad:  "price_1TDR67BTQT1Q7jEloVo6j6xY", // CAD $2,870.40/yr
    },
    displayPrices: {
      monthly_usd: 249,
      annual_usd:  2388,
      monthly_cad: 299,
      annual_cad:  2870.40,
    },
    features: ["All Starter Features", "Up to 10 Users", "Advanced Reporting"],
  },
  scale: {
    name: "Spatchy Scale",
    userLimit: 20,
    prices: {
      monthly:     "price_1TDR68BTQT1Q7jEll9YFbnl4", // USD $449/mo
      annual:      "price_1TDR67BTQT1Q7jElphtMI8uv", // USD $4,308/yr
      monthly_cad: "price_1TDR67BTQT1Q7jElkFC1eaQO", // CAD $499/mo
      annual_cad:  "price_1TDR66BTQT1Q7jEl0r8kLeiE", // CAD $4,790.40/yr
    },
    displayPrices: {
      monthly_usd: 449,
      annual_usd:  4308,
      monthly_cad: 499,
      annual_cad:  4790.40,
    },
    features: ["All Growth Features", "Up to 20 Users", "Priority Support"],
  },
};